import { environment } from 'environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatChipInputEvent } from '@angular/material/chips';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { PrecoService } from './../../../service/produto/preco.service';
import { ProdutoModel } from './../../../model/produto/produto.model';
import { ProdutoService } from './../../../service/produto/produto.service';
import { AreaService } from 'app/service/cliente/area.service';
import { ResponsePageable } from '../../../model/cliente/pageable/responsePageable.model';
import { Component, Input, OnInit, ViewChild, ElementRef, TemplateRef, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AreaModel } from 'app/model/cliente/area.model';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { GrupoClienteModel } from 'app/model/cliente/grupocliente.model';
import { IndiceReajusteModel } from 'app/model/cliente/indicereajuste.model';
import { RamoAtividadeModel } from 'app/model/cliente/ramoatividade.model';
import { TipoClienteModel } from 'app/model/cliente/tipocliente.model';
import { TipoReajusteModel } from 'app/model/cliente/tiporeajuste.model';
import { ClienteService } from 'app/service/cliente/cliente.service';
import {MatDialog} from '@angular/material/dialog';
import { PrecoModel } from 'app/model/produto/preco.model';
import * as CryptoJS from 'crypto-js';
import { AuthenticationService } from '@alfresco/adf-core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';


export interface Aplicabilidade {
  descricaoCategoriaProduto: string;
}

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  aplicabilidadeChips: Aplicabilidade[] = [];
  loading = true;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  maskCpf = [/\d/, /\d/, /\d/,'.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]

  // 19.045.470/0001-08
  maskCnpj = [/\d/, /\d/,'.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]

  queryField = new FormControl();

  @ViewChild('closeModal') closeModal: ElementRef;
  @ViewChild('content') private contentRef: TemplateRef<Object>;

  precoModal = false;
  editPreco = false;
  edit = false;
  editShow = false;

  public submit = false;
  public countClientes = 0;

  EhNovoCliente = false;

  @Input() clienteProp: ClienteModel;

  public clienteForm: FormGroup;
  public precoForm: FormGroup;

  produto = {} as ProdutoModel;
  produtos: ProdutoModel[];

  cliente = {} as ClienteModel;
  clientes: ClienteModel[];

  clienteBusca = {} as ClienteModel;
  clienteBuscas: ClienteModel[];

  tipoCliente = {} as TipoClienteModel;
  tipoClientes: TipoClienteModel[];

  arrayString: string;

  area = {} as AreaModel;
  areas: AreaModel[];

  precoPadraoPorProduto = {} as PrecoModel;

  ramoAtividade = {} as RamoAtividadeModel;
  ramoAtividades: RamoAtividadeModel[];

  grupoCliente = {} as GrupoClienteModel;
  grupoClientes: GrupoClienteModel[];

  indiceReajuste = {} as IndiceReajusteModel;
  indiceReajustes: IndiceReajusteModel[];

  tipoReajuste = {} as TipoReajusteModel;
  tipoReajustes: TipoReajusteModel[];

  public page: ResponsePageable;

  public pageProduto: ResponsePageable;

  public apiURL = environment.API;

  selectedMovimentacao: boolean = false;
  selectedTransporte: boolean = false;
  spinner = false;

  public pageAtual = 0;

  public selectedValue = 0;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;

  public inativo = true;

  user: any;
  userAdmin = false;
  userUser = false;
  userEditor = false;
  userCreator = false;

  progress: boolean = false;

  public idNovoCliente;

  emitirCliente = new EventEmitter<number>();

  public idToEncript = 8;

  public superUser = false;
  public createEmpresa = false;
  public editEmpresa = false;
  public deleteEmpresa = false;
  public viewEmpresa = false;
  public ativado = false;
  public desativado = false;

  public clienteId: any;
  public deData: any;
  public idEmpresa: any;
  public idEmpresaExcluir: any;

  adm = true;
  acervo = false;
  solicitacao = false;

  constructor(
    private route: ActivatedRoute,
    public clienteService: ClienteService,
    private fb: FormBuilder,
    private areaService: AreaService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private produtoService: ProdutoService,
    private precoService: PrecoService,
    private router: Router,
    private authService: AuthenticationService,
    private permissionService: PermissoesService,
    private httpCliente: HttpClient) {
      this.route.params.subscribe(params => this.clienteId = params['id']);
      this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.clienteId), 'pcdoc');
      this.clienteId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
     }

  ngOnInit() {

    this.clienteForm = this.fb.group({
      nome: ['', [Validators.maxLength(80)]],
      selectedValue: [null],
      cpf: ['', [Validators.required]],
      email: ['', [Validators.required]],
      nomeFantasia: ['', [Validators.maxLength(80)]],
      responsavel: ['', [Validators.maxLength(80)]],
      inscricaoEstadual: ['', [Validators.maxLength(80)]],
      inscricaoMunicipal: ['', [Validators.maxLength(80)]],
      observacao: ['', [Validators.maxLength(255)]],
      dataReajuste: ['', [Validators.required]],
      tipoClientes: ['', [Validators.required]],
      ramoAtividade: [RamoAtividadeModel, [Validators.required]],
      grupoCliente: [GrupoClienteModel , [Validators.required]],
      indiceReajuste: [IndiceReajusteModel, [Validators.required]],
      tipoReajuste: [TipoReajusteModel, [Validators.required]],
      tipoCliente: [TipoClienteModel, [Validators.required]],
      area: [[AreaModel], [Validators.required]]
    });

    this.precoForm = this.fb.group({
      utilizacao: ['', Validators.required],
      armazenagem: ['', Validators.required],
      movImplantacao: ['', Validators.required],
      movEntrada: ['', Validators.required],
      movSaidaNormal: ['', Validators.required],
      movSaidaUrgente: ['', Validators.required],
      transImplantacao: ['', Validators.required],
      transEntrada: ['', Validators.required],
      transSaidaNormal: ['', Validators.required],
      transSaidaUrgente: ['', Validators.required],
      selectedMovimentacao: [false],
      selectedTransporte: [false]
    });

    this.detalheCliente(this.clienteId);
    this.getPermissionCliente(this.clienteId);
  }

  getIdEmpresa(id: number) {
    this.idEmpresa = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(id), 'pcdoc').toString());
    this.router.navigate(['/editar-cliente', this.idEmpresa]);
  }

  getPrecoPadrao(id: number) {
    this.precoService.getPrecoPadraoPorProduto(id).subscribe(data => {
      this.precoPadraoPorProduto = data;
    });
  }

  sendData() {
    this.clienteService.getClientes().subscribe(data => {
      this.clienteService.dataCliente = data.content;
    }, error => {
      console.error(error);
    });
    this.router.navigate(['home']);
  }

  getDadosEditPreco(preco: PrecoModel) {
    this.precoPadraoPorProduto = { ...preco};
    this.editPreco = true;
    this.edit = true;
    this.editShow = true;
    this.selectedMovimentacao = true;
    this.selectedTransporte = true;
  }

  showModal(){
    this.precoModal = true;
    this.precoPadraoPorProduto;
  }

  onSearch() {
    if (this.queryField.value === '') {
      this.listarPageClientes(0, 10, this.queryField.value);
    } else {
      this.listarPageClientes(null, null, this.queryField.value);
    }
  }

  listPageProdutos(page, size) {
    this.produtoService.getPageProduto(page, size).subscribe(data => {
      this.pageProduto = data;
      this.produtos = this.pageProduto.content;
    });
  }

  getDadosAddProduto(cliente: ClienteModel){
    this.cliente = { ...cliente}
  }

  getDadosAddProduto2(cliente: ClienteModel, produto: ProdutoModel){
    this.cliente = { ...cliente};
    this.produto = { ...produto};

  }

  getDados(){
    this.getTipoCliente();
    this.getGrupoCliente();
    this.getIndiceReajuste();
    this.getRamoAtividade();
    this.getTipoReajuste();
    this.postSubmit();
    this.setAreaClienteNull();
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
      this.spinner = true;
    }, err => {
      console.error(err);
    });
  }

  detalheCliente(id: number) {
    this.clienteService.getClienteUnico(id).subscribe(data => {
      this.cliente = data;
      this.spinner = true;
      if (this.cliente.status === false) {
        this.inativo = false;
      } else {
        this.inativo = true;
      }
    }, err => {
      console.error(err);
    });
  }

  listarPageClientes(page, size, nome) {
    this.clienteService.getPageClientes(page, size, nome).subscribe(res => {
      this.page = res;
      this.clientes = this.page.content;
      this.spinner = true;
      this.countClientes = res.totalElements;
    });
    this.progress = true;
  }

  openDialogCliente() {
    const dialogRef = this.dialog.open(ClientesComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  changePage(event) {
    this.listarPageClientes(event.page, event.size, '');
    this.pageAtual = event.page;
   }

  onSubmit(){
    this.submit = true;
  }

  postSubmit(){
    this.submit = false;
    this.clienteForm.reset();
  }

  compararEditCliente(obj1, obj2) {
    return obj1 && obj2 ? (obj1.descricao === obj2.descricao && obj1.id === obj2.id) : obj1 === obj2;
  }

  clickNovoCliente(){
    this.cliente.id = undefined;
    this.getDados();
  }

  saveOrEditCliente(){
    if(this.cliente.id !== undefined){
      this.EhNovoCliente = false;
      this.editarCliente();
    } else {
      this.EhNovoCliente = true;
      this.postCliente();
    }
  }

  // Editar Cliente
  editarCliente() {
    this.clienteService.putCliente(this.cliente).subscribe(data =>{
      this.listarPageClientes(this.pageAtual, 10, '');
      this.openSnackBarSuccess('Cliente atualizado com sucesso!');
    }, err => {
      console.log(err);
    });
  }

  // Adicionar novo cliente
  postCliente() {
      this.clienteService.saveCliente(this.clienteForm.value).subscribe(result =>{
        this.cliente = new ClienteModel();
        this.clienteForm.reset();
        this.openSnackBarSuccess('Cliente salvo com sucesso !');
        this.postSubmit();
        this.listarPageClientes(0, 10, '');
      }, function(error){
        console.log(error);
        if(error.status === 400) {
          this.openSnackBarError('Este CPF ou CNPJ já está cadastrado !');
        }
      });
  }

  getDadosEdit(cliente: ClienteModel){
    this.cliente = { ...cliente}
    this.clienteForm.get('ramoAtividade').setValue(cliente.ramoAtividade);
    this.clienteForm.get('grupoCliente').setValue(cliente.grupoCliente);
    this.clienteForm.get('indiceReajuste').setValue(cliente.indiceReajuste);
    this.clienteForm.get('tipoReajuste').setValue(cliente.tipoReajuste);
    this.clienteForm.get('tipoCliente').setValue(cliente.tipoCliente);
    this.getAreasCliente(cliente.id);
    this.emitirCliente.emit(cliente.id);

    const encrypted = CryptoJS.AES.encrypt(this.idToEncript.toString(), 'teste');
    const decrypted = CryptoJS.AES.decrypt(encrypted, 'teste');
  }

  confirmeExclusao(cliente: ClienteModel) {
    const confirme = confirm('Tem certeza que deseja excluir este cliente ?');
    if (confirme === true) {
      this.desativarCliente(cliente);
    } else {
      console.log('Cancelou exclusão!');
    }
  }

  apagarCliente(id: number) {
    this.clienteService.deleteCliente(id).subscribe(() => {
      this.openSnackBarSuccess('Cliente excluído com sucesso !');;
      setTimeout(() => {
        this.router.navigate(['/clientes']);
      }, 2500);
    }, error => {
      console.log(error);
      this.openSnackBarError('Erro ao tentar excluir o cliente !');
    });
  }

  desativarCliente(cliente: ClienteModel) {
    this.clienteService.desativarCliente(cliente).subscribe(data => {
      this.openSnackBarSuccess('Cliente desativado com sucesso !');
      setTimeout(() => {
        this.router.navigate(['/clientes']);
      }, 2500);
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar desativar Cliente !');
    });
  }

  ativarCliente(cliente: ClienteModel) {
    this.clienteService.ativarCliente(cliente).subscribe(data => {
      this.openSnackBarSuccess('Cliente ativado com sucesso !');
      setTimeout(() => {
        this.router.navigate(['/clientes']);
      }, 2500);
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar ativar o Cliente !');
    });
  }

  getPageArea(page, size){
    this.areaService.getPageAreas(page, size).subscribe(data => {
      this.page = data;
      this.areas = this.page.content;
    })
  }

  getTipoCliente(){
    this.clienteService.getTipoCliente().subscribe(data => {
      this.tipoClientes = data.content;

    })
  }

  getGrupoCliente(){
    this.clienteService.getGrupoCliente().subscribe(data => {
      this.grupoClientes = data.content;

    })
  }

  getRamoAtividade(){
    this.clienteService.getRamoAtividade().subscribe(data => {
      this.ramoAtividades = data.content;

    })
  }

  getIndiceReajuste() {
    this.clienteService.getIndiceReajuste().subscribe(data => {
      this.indiceReajustes = data.content;

    })
  }

  setAreaClienteNull(){
    this.areas = [];
  }

  getAreasCliente(id: number){
    if(this.cliente.id !== undefined){

      this.areaService.getAreasCliente(id).subscribe(data => {

        this.areas = data;
      }, err => {
        console.log(err);
      })
    } else {
      console.log('Novo cliente!');
    }
  }

  getTipoReajuste(){
    this.clienteService.getTipoReajuste().subscribe(data => {
      this.tipoReajustes = data.content;
    })
  }

  // ADICIONAR CHIPS CATEGORIZAÇÃO
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    // Add our fruit
    if ((value || '').trim()) {
      this.aplicabilidadeChips.push(
        {
          descricaoCategoriaProduto: value.trim()
        }
      );

      const categorizacao = this.precoForm.get('aplicabilidades');
      categorizacao.setValue(new FormControl({ descricaoCategoriaProduto: value.trim() }));
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  //REMOVER CHIPS DE CATEGORIZAÇÃO
  remove(aplicabilidade: Aplicabilidade): void {
    const index = this.aplicabilidadeChips.indexOf(aplicabilidade);
    const categorizacao = this.precoForm.get('aplicabilidades');

    if (index >= 0) {
      this.aplicabilidadeChips.splice(index, 1);
      //categorizacao.removeAt(index);
    }
  }

  getPermissionCliente(idCliente: number) {
    const headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    this.httpCliente.get<any>(this.apiURL + `/permission/get-permission-por-cliente/${idCliente}`, { headers }).subscribe(data => {
      console.log('entrei');
        const arrayAuthorityCliente: any[] = [];
        data.forEach(el => {
          arrayAuthorityCliente.push(el.authority);
        });
        this.setItemAuthority('authority-Empresa', arrayAuthorityCliente);
        this.getAuthority();
  }, err => {
    console.log(err);
    this.loading = false;
    if (err.status === 401) {
      this.loading = false;
    }
  });
}

  setItemAuthority(key, value) {
    const store: any = CryptoJS.AES.encrypt(JSON.stringify(value), sessionStorage.getItem('ticket-ECM'));
    return sessionStorage.setItem(key, store);
  }

  getAuthority() {
    setTimeout(() => {
      this.getItemAuthority('authority-Empresa');
      if (this.arrayString.includes('LIST_EMPRESA')) {
        this.viewEmpresa = true;
      }
      if (this.arrayString.includes('DELETE_EMPRESA')) {
        this.deleteEmpresa = true;
      }
      if (this.arrayString.includes('EDIT_EMPRESA')) {
        this.editEmpresa = true;
      }
      if (this.arrayString.includes('ADD_EMPRESA')) {
        this.createEmpresa = true;
      }
      if (this.arrayString.includes('SUPER_USER')) {
        this.superUser = true;
      }
      this.loading = false;
    }, 4000);
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
        try {
            const bytes = CryptoJS.AES.decrypt(store, sessionStorage.getItem('ticket-ECM'));
            this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return this.arrayString;
        } catch (e) {
            sessionStorage.clear();
        }
    }

    return null;
  }


  getUserLogado() {
    this.permissionService.getUserLogado().subscribe(data => {
      this.user = data;

      this.user.forEach(el => {
        if (el.authority === 'ADMIN') {
          this.userAdmin = true;
        }
        if (el.authority === 'USER') {
          this.userUser = true;
        }
        if (el.authority === 'CREATOR') {
          this.userCreator = true;
        }
        if (el.authority === 'EDITOR') {
          this.userEditor = true;
        }
      });
    }, err => {
      console.error(err);
    });
  }

// SnackBares
openSnackBarSuccess(message: string) {
  this._snackBar.open(message, '', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar']
  });
}

openSnackBarError(message: string) {
  this._snackBar.open(message,'', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 3000,
    panelClass: ['error-snackbar']
  });
}
}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/clientes/clientes.component.ts